import { useModal } from 'mui-modal-provider';
import { useCallback, useEffect, useMemo } from 'react';
import {
    Background,
    Controls,
    Node,
    ReactFlow,
    useNodesInitialized,
    useReactFlow,
} from 'reactflow';
import 'reactflow/dist/style.css';
import { AiSmartReplyPlan, AiSmartReplyPlanItem } from '../../../../../sic-lib/api/ai/types/Ai';
import { AiSmartReplyPlanItemsPrompt } from '../../../../../sic-lib/types/Ai';
import { convertPlanItemsToGraph } from '../../../../../utils/reactFlowHelpers';
import { CreateSmartReplyPlanItemDrawer } from '../CreatePlanItem/CreateSmartReplyPlanItemDrawer';
import { EditSmartReplyPlanItemDrawer } from '../EditSmartReplyPlanItemDrawer';
import { PlanItemNode } from './PlanItemNode';

interface Props {
    planItems: AiSmartReplyPlanItemsPrompt[];
    plan: AiSmartReplyPlan;
}

const nodeTypes = {
    planItem: PlanItemNode,
};

export function SmartReplyFlow({ planItems, plan }: Props) {
    const { showModal } = useModal();
    const { fitView } = useReactFlow();
    const nodesInitialized = useNodesInitialized();

    const handleNodeClick = useCallback(
        (event: React.MouseEvent, node: Node) => {
            console.log('Node clicked', node, node.data.promptId);
            if (node.id === 'newPlanItem') {
                //the last planItem
                const lastItem = planItems.at(-1);
                const payload =
                    lastItem ||
                    ({
                        planId: plan.planId,
                        parentPlanItemId: undefined,
                    } as AiSmartReplyPlanItem);

                const modal = showModal(CreateSmartReplyPlanItemDrawer, {
                    plan: plan,
                    parentItem: payload,
                    onCancel: () => {
                        modal.hide();
                    },
                    onConfirm: () => {
                        modal.hide();
                    },
                });
            } else {
                const modal = showModal(EditSmartReplyPlanItemDrawer, {
                    plan: plan,
                    planItem: node.data.planItem,
                    onCancel: () => {
                        modal.hide();
                    },
                    onConfirm: () => {
                        modal.hide();
                    },
                });
            }
        },
        [plan.planId, planItems],
    );

    const { nodes, edges } = useMemo(() => convertPlanItemsToGraph(planItems), [planItems]);

    useEffect(() => {
        if (nodesInitialized) {
            window.requestAnimationFrame(() => {
                fitView();
            });
        }
    }, [nodes, edges, nodesInitialized, fitView]);

    return (
        <>
            {/* <EditSmartReplyPlanItemDrawer
                planItem={editingPlanItem}
                setEditingPlanItem={setEditingPlanItem}
                plan={plan}
            />
            <CreateSmartReplyPlanItemDrawer
                parentItem={parentPlanItem}
                setParentItem={setParentPlanItem}
                plan={plan}
            /> */}
            <div style={{ height: '100%' }}>
                <ReactFlow
                    nodeTypes={nodeTypes}
                    nodesDraggable={false}
                    nodesConnectable={false}
                    elementsSelectable={false}
                    nodes={nodes || []}
                    edges={edges || []}
                    fitView
                    onNodeClick={handleNodeClick}
                    proOptions={{ hideAttribution: true }}
                >
                    <Background />
                    <Controls />
                </ReactFlow>
            </div>
        </>
    );
}
